<template>
  <div>
    <h3
      class="mb-md-10 mb-10 font-weight-boldest text-dark text-center payment-title"
    >
      Choose Your Package
    </h3>
    <div class="text-center mt-5 mb-5 mb-md-20 mt-md-20">
      <b-form-group class="packages">
        <b-form-radio-group
          id="payment-packages"
          v-model="current_package"
          buttons
          size="lg"
          name="packages"
        >
          <b-form-radio
            class="offer-package-button ribbon ribbon-clip ribbon-right"
            value="one_year_plan_id"
          >
            $7.49 / month
            <div class="ribbon-target">
              <span class="ribbon-inner"></span>Save 60%
            </div>
          </b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <b-row align-h="end">
        <b-col cols="12">
          <div class="package-desc font-weight-bold">
            Billed yearly $89.99
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Default",
  props: {
    showHalfYearOption: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      current_package: "one_year_plan_id"
    };
  },
  watch: {
    current_package: function(val) {
      this.$emit("input", val);
    }
  }
};
</script>
